<div class="general-body bg-light">
    <div class="background-container">
        <div class="background-image">
            <img src="../../../assets/img/Backkground.png" alt="Background Image" class="background-pic" draggable="false">
        </div>
        <div class="cards-container container">
            <div class="faqs-content">
                <div class="faqs-header">
                    <h2 class="faqs-title">Frequently Asked Questions</h2>
                </div>

                <div class="faqs-accordion-container">
                    <div *ngIf="faqs.length === 0" class="no-faqs-message">
                        <p>No FAQs available at the moment.</p>
                    </div>

                    <div class="accordion" id="faqsAccordion" *ngIf="faqs.length > 0">
                        <div class="accordion-item" *ngFor="let faq of faqs; let i = index">
                            <h2 class="accordion-header" [id]="'heading' + i">
                                <button 
                                    class="accordion-button" 
                                    type="button" 
                                    [attr.data-bs-toggle]="'collapse'" 
                                    [attr.data-bs-target]="'#collapse' + i"
                                    [attr.aria-expanded]="i === 0 ? 'true' : 'false'"
                                    [attr.aria-controls]="'collapse' + i"
                                    [class.collapsed]="i !== 0">
                                    <span class="faq-question">{{ faq.question }}</span>
                                </button>
                            </h2>
                            <div 
                                [id]="'collapse' + i" 
                                class="accordion-collapse collapse" 
                                [class.show]="i === 0"
                                [attr.aria-labelledby]="'heading' + i" 
                                data-bs-parent="#faqsAccordion">
                                <div class="accordion-body">
                                    <div class="faq-answer">
                                        <p>{{ faq.answer }}</p>
                                        <div *ngIf="faq.linkedTenderTitle" class="faq-tender-link">
                                            <small class="text-muted">
                                                <strong>Related Tender:</strong> {{ faq.linkedTenderTitle }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

